import React, { useContext, useEffect, useState } from "react";
import useDeviceType from "Utils/useDeviceType";
import QuestionnaireMobile from "./components/QuestionnaireMobile";
import QuestionnairePC from "./components/QuestionnairePC";
import { useHistory, useParams } from "react-router-dom";
import { errorMessage } from "../../../../Utils/useRequest";
import {
    BaseQuestionType,
    getPaper,
    PaperProps,
    QuestionnaireProps,
    questionSubmit,
    saveOne
} from "../service";
import { CourseContext } from "../../Store";
import { message, Modal } from "antd";
import { ResultMessage } from "../../../../components/ResultMessage";
import QuestionnaireTopicsHeader from "./components/QuestionnairePC/components/QuestionnaireTopicsHeader";
import QuestionnaireTopicsButtons from "./components/QuestionnaireMobile/components/QuestionnaireTopicButtons";
import { QuestionnaireContext, QuestionnaireOptionItem } from "../store";
import { isTrue } from "../../../../Utils/filter";

export default function QuestionnaireTopics() {
    const history = useHistory();
    const { isPC } = useDeviceType();
    const { course } = useContext(CourseContext);
    const { questionnaireId } = useParams<{ questionnaireId: string }>();
    const [data, setData] = useState<PaperProps>();
    const [headerData, setHeaderData] = useState<QuestionnaireProps>();
    const [questionnaire, setQuestionnaire] = useState<
        QuestionnaireOptionItem[]
    >([]);
    const [showQuestionnaireBar, setShowQuestionnaireBar] = useState(false); //手机端答题卡显示隐藏
    const [stop, setStop] = useState<number | null | undefined>(5000); //每5s检测问卷状态

    useEffect(() => {
        getPaperData();
    }, []);

    // ----------初始化处理context中questionnaire的缓存值start(queTypeId,1单选，2判断，3多选，4主关，5填空，>=6阅读理解，自定义)---------
    useEffect(() => {
        if (!data) return;
        if (data.topics.length !== 0) {
            let list = data.topics;
            let array: QuestionnaireOptionItem[] = [];
            list.forEach(item => {
                if (
                    item.queTypeId === BaseQuestionType.SingleChoice ||
                    item.queTypeId === BaseQuestionType.Subjective
                ) {
                    array.push({
                        id: item.id,
                        isAnswer: !!item.stuAns,
                        requireFlag: item.requiredFlag,
                        oneAnswer: item.stuAns ? item.stuAns : ""
                    });
                } else if (item.queTypeId === BaseQuestionType.MultipleChoice) {
                    if (item.stuAns) {
                        let answer = JSON.parse(item.stuAns);
                        array.push({
                            id: item.id,
                            isAnswer: answer.length > 0,
                            requireFlag: item.requiredFlag,
                            moreAnswer: JSON.parse(item.stuAns)
                        });
                    } else {
                        array.push({
                            id: item.id,
                            isAnswer: false,
                            requireFlag: item.requiredFlag,
                            moreAnswer: null
                        });
                    }
                }
            });
            setQuestionnaire(array);
        }
    }, [data]);
    // ----------初始化处理context中questionnaire的缓存值end---------

    async function getPaperData() {
        try {
            let data = await getPaper(questionnaireId);
            setData(data);
        } catch (e) {}
    }

    function oneChange(questionId: string, value: any) {
        let array = questionnaire;
        array.forEach(item => {
            if (item.id === questionId) {
                item.oneAnswer = value;
                item.isAnswer = !!value;
            }
        });
        setQuestionnaire(array);
    }

    function moreChange(questionId: string, value: any) {
        let array = questionnaire;
        array.forEach(item => {
            if (item.id === questionId) {
                item.moreAnswer = value;

                if (value instanceof Array) {
                    //value为数组是多选题
                    value.length > 0
                        ? (item.isAnswer = true)
                        : (item.isAnswer = false);
                }
            }
        });

        setQuestionnaire(array);
    }

    async function oneSave(questionId: string, value: string) {
        //1单选，3判断,4主观保存
        try {
            await saveOne(questionnaireId, questionId, value);
            oneChange(questionId, value); //改变context里缓存的值
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    async function moreSave(questionId: string, value: any) {
        //2多选，5填空
        try {
            await saveOne(questionnaireId, questionId, JSON.stringify(value));
            moreChange(questionId, value); //改变context里缓存的值
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    // -------------提交操作start--------------
    async function onSubmit(showConfirm: boolean = true) {
        let number = 0;
        let must = 0;
        data?.topics.map(dataItem => {
            let id = dataItem.id;
            questionnaire.map(item => {
                if (id === item.id && !item.isAnswer) {
                    number++;
                }
                if (
                    id === item.id &&
                    !item.isAnswer &&
                    isTrue(item.requireFlag)
                ) {
                    must++;
                }
            });
        });

        if (must > 0) {
            return message.warning(
                `有${must}道题必填，请检查左侧答题卡带*题目，作答后再次提交。`
            );
        }

        // 不显示确认信息
        if (!showConfirm) {
            await submit();
            return { number };
        }

        Modal.confirm({
            title: `确认提交问卷？`,
            content: `${
                number > 0 ? `还有${number}道题尚未作答，` : ""
            }确认提交后不可修改作答内容，确认要提交问卷？`,
            okText: "提交",
            cancelText: "继续作答",
            onOk: () => submit()
        });
    }

    async function submit() {
        //调提交接口
        let paperAnswer: any = [];
        questionnaire.map(item => {
            if ("oneAnswer" in item) {
                paperAnswer.push({
                    [item.id]: item.oneAnswer
                });
            }
            if ("moreAnswer" in item) {
                paperAnswer.push({
                    [item.id]: item.moreAnswer
                });
            }
        });

        try {
            await questionSubmit(
                course.courseId,
                questionnaireId,
                JSON.stringify(paperAnswer)
            );
            ResultMessage.success("提交成功！");
            history.goBack();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function barShow() {
        setShowQuestionnaireBar(true);
    }

    function questionnaireBarClose() {
        setShowQuestionnaireBar(false);
    }

    return (
        <div>
            <QuestionnaireContext.Provider value={{ questionnaire }}>
                {isPC && (
                    <QuestionnairePC
                        data={data}
                        oneChange={oneChange}
                        moreChange={moreChange}
                        oneSave={oneSave}
                        moreSave={moreSave}
                        headerDom={
                            <QuestionnaireTopicsHeader
                                onSubmit={onSubmit}
                                questionnaireId={questionnaireId}
                            />
                        }
                    />
                )}

                {!isPC && (
                    <QuestionnaireMobile
                        data={data}
                        oneChange={oneChange}
                        moreChange={moreChange}
                        oneSave={oneSave}
                        moreSave={moreSave}
                        headerDom={
                            <QuestionnaireTopicsButtons
                                data={data}
                                barShow={barShow}
                                questionnaireId={questionnaireId}
                            />
                        }
                        onSubmit={onSubmit}
                        showQuestionnaireBar={showQuestionnaireBar}
                        questionnaireBarClose={questionnaireBarClose}
                    />
                )}
            </QuestionnaireContext.Provider>
        </div>
    );
}
